<template>
  <div class="main-profile">
    <div class="edit-profile">
      <div class="edit-profile-head" v-if="noInvoices">
        <h1>
          <span>{{
            $t("miCuenta.titulo", {
              nombre: this.getNameByType(
                usuario.nombre,
                usuario.razonSocial,
                this.esEntidad(usuario.tipo)
              ),
            })
          }}</span>
        </h1>
        <h2>{{ $t("miCuenta.h2") }}</h2>

        <div class="profile-radio">
          <div class="profile-radio__item">
            <input
              type="radio"
              value="female"
              :checked="this.isChecked('female')"
              name="female"
              id="female"
              v-model="genero"
              v-on:change="asignarAvatar(modificarGeneroRequest())"
            />
            <label><img src="@/assets/profile/female.png" /></label>
          </div>
          <div class="profile-radio__item">
            <input
              type="radio"
              value="male"
              :checked="this.isChecked('male')"
              name="male"
              id="male"
              v-model="genero"
              v-on:change="asignarAvatar(modificarGeneroRequest())"
            />
            <label><img src="@/assets/profile/male.png" /></label>
          </div>
          <div class="profile-radio__item">
            <input
              type="radio"
              value="company"
              :checked="this.isChecked('company')"
              name="company"
              id="company"
              v-model="genero"
              v-on:change="asignarAvatar(modificarGeneroRequest())"
            />
            <label><img src="@/assets/profile/company.png" /></label>
          </div>
          <div class="profile-radio__item">
            <input
              type="radio"
              value="mug"
              :checked="this.isChecked('mug')"
              name="mug"
              id="mug"
              v-model="genero"
              v-on:change="asignarAvatar(modificarGeneroRequest())"
            />
            <label><img src="@/assets/profile/mug.png" /></label>
          </div>
          <div class="profile-radio__item">
            <input
              type="radio"
              value="abstract"
              :checked="this.isChecked('abstract')"
              name="abstract"
              id="abstract"
              v-model="genero"
              v-on:change="asignarAvatar(modificarGeneroRequest())"
            />
            <label><img src="@/assets/profile/abstract.png" /></label>
          </div>
        </div>
      </div>
      <div class="edit-profile-body" v-if="noInvoices">
        <div class="container-white">
          <h2>{{ $t("miCuenta.datosPersonales") }}</h2>
          <div class="grid fluid">
            <div class="col-12 md:col-6 p-field">
              <label for="usuarioNombre">{{
                this.$t("miCuenta.labels.nombre")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationUsuario.nombre === false && 'p-invalid'
                  }`"
                  id="usuarioNombre"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.nombre')"
                  v-model="usuario.nombre"
                />
              </div>
              <small
                v-if="validationUsuario.nombre === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field">
              <label for="usuarioApellidos">{{
                this.$t("miCuenta.labels.apellidos")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationUsuario.apellidos === false && 'p-invalid'
                  }`"
                  id="usuarioApellidos"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.apellidos')"
                  v-model="usuario.apellidos"
                />
              </div>
              <small
                v-if="validationUsuario.apellidos === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field">
              <label for="usuarioNif">{{
                this.$t("miCuenta.labels.nif") +
                (this.$store.state.esGranCliente ? "" : "*")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationUsuario.idLegal === false && 'p-invalid'
                  }`"
                  id="usuarioNif"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.nif')"
                  v-model="usuarioNif"
                  @input="usuarioNif = usuarioNif.toUpperCase()"
                />
              </div>
              <small
                v-if="validationUsuario.idLegal === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field">
              <label for="usuarioPhone">{{
                this.$t("miCuenta.labels.telefono")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationUsuario.telefono === false && 'p-invalid'
                  }`"
                  id="usuarioPhone"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.telefono')"
                  v-model="usuarioTelefono"
                />
              </div>
              <small
                v-if="validationUsuario.telefono === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field md:col-offset-6">
              <Button
                :disabled="isSubmitting"
                @click="modificarUsuario(modificarUsuarioRequest())"
                :label="$t('common.buttons.saveChanges')"
                class="button"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="edit-profile-body" v-if="noInvoices">
        <div class="container-white">
          <h2>{{ $t("miCuenta.datosFacturacion") }}</h2>
          <div class="grid fluid">
            <div class="col-12 md:col-6 p-field">
              <label for="clienteCifNif">{{
                this.$t("miCuenta.labels.nifCliente")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationCliente.idLegal === false && 'p-invalid'
                  }`"
                  id="clienteCifNif"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.nifCliente')"
                  v-model="clienteNif"
                  @input="clienteNif = clienteNif.toUpperCase()"
                />
              </div>
              <small
                v-if="validationCliente.idLegal === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field">
              <label for="clientePhone">{{
                this.$t("miCuenta.labels.telefonoCliente")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationCliente.telefono === false && 'p-invalid'
                  }`"
                  id="clientePhone"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.telefonoCliente')"
                  v-model="clienteTelefono"
                />
              </div>
              <small
                v-if="validationCliente.telefono === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>

            <div class="col-12 md:col-6 p-field">
              <label for="clienteNombre">{{ labelClienteNombre }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input  input-style ${
                    validationCliente.nombre === false && 'p-invalid'
                  }`"
                  id="clienteNombre"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.nombreCliente')"
                  v-model="cliente.nombre"
                />
              </div>
              <small
                v-if="validationCliente.nombre === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field" v-if="showApellidos">
              <span>
                <label for="clienteApellidos">{{
                  labelClienteApellidos
                }}</label>
                <div class="p-inputgroup">
                  <InputText
                    :class="`input  input-style ${
                      validationCliente.apellidos === false && 'p-invalid'
                    }`"
                    id="clienteApellidos"
                    type="text"
                    :placeholder="$t('miCuenta.placeholders.apellidosCliente')"
                    v-model="cliente.apellidos"
                  />
                </div>
                <small
                  v-if="validationCliente.apellidos === false"
                  class="p-invalid"
                  >{{ this.$t("common.formularios.fieldNoValid") }}</small
                >
              </span>
            </div>
            <div class="p-col-12 p-md-6 p-field" v-if="!showApellidos"></div>

            <DireccionIcired
              :required="true"
              ref="direccionComponent"
              />

            <div class="col-12 md:col-6 p-field md:col-offset-6">
              <Button
                :disabled="
                  loadingCTIAddressNormalization ||
                  isSubmitting ||
                  clientNotVerifyValidations ||
                  !canSubmitClient
                "
                @click="modificarOAltaCliente()"
                :label="$t('common.buttons.saveChanges')"
                class="button"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.usuario && noInvoices" class="edit-profile-body">
        <div class="container-white">
          <h2>{{ this.$t("miCuenta.datosCommercialCommunications") }}</h2>
          <div class="grid fluid">
            <div class="col-12 md:col-12 p-field">
              {{ this.$t("miCuenta.textos.commercialCommunications.1") }}
            </div>
            <div class="col-12 md:col-12 p-field">
              <InputSwitch
                style="top: 10px"
                v-model="commercialCommunications"
              />
              {{ this.$t("miCuenta.textos.commercialCommunications.switch") }}
            </div>
            <div class="col-12 md:col-6 p-field md:col-offset-6">
              <Button
                :disabled="isSubmitting"
                @click="
                  modificarCommercialCommunications(
                    modificarCommercialCommunicationsRequest()
                  )
                "
                :label="$t('common.buttons.saveChanges')"
                class="button"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.usuario && noInvoices"
        class="edit-profile-body profile__change-email"
      >
        <div class="container-white">
          <h2>{{ this.$t("miCuenta.datosEmail") }}</h2>
          <div class="grid fluid">
            <div class="col-12 md:col-6 p-field">
              <label for="correoEmail">{{
                this.$t("miCuenta.labels.oldEmail")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  class="input input-style"
                  id="correoEmail"
                  type="text"
                  v-model="this.oldEmail"
                  disabled="true"
                />
              </div>
            </div>
            <div class="col-12 md:col-6 p-field">
              <label for="nuevoEmail">{{
                this.$t("miCuenta.labels.newEmail")
              }}</label>
              <div class="p-inputgroup">
                <InputText
                  :class="`input input-style ${
                    validationEmail.nuevoEmail === false && 'p-invalid'
                  }`"
                  id="nuevoEmail"
                  type="text"
                  :placeholder="$t('miCuenta.placeholders.email')"
                  v-model="nuevoEmail"
                />
              </div>
              <small
                v-if="validationEmail.nuevoEmail === false"
                class="p-invalid"
                >{{ this.$t("common.formularios.fieldNoValid") }}</small
              >
            </div>
            <div class="col-12 md:col-6 p-field">
              <div class="forget-pass-text">
                {{ this.$t("miCuenta.textos.email.1") }}
              </div>
              <div class="forget-pass-text">
                {{ this.$t("miCuenta.textos.email.2") }}
              </div>
            </div>
            <div class="col-12 md:col-6 p-field">
              <Button
                :disabled="isSubmitting"
                :label="$t('common.buttons.saveChanges')"
                class="button"
                id="update_email"
                @click="cambiarEmail()"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.usuario && noInvoices"
        class="edit-profile-body profile__change-pass"
      >
        <div class="container-white">
          <h2>{{ this.$t("miCuenta.datosPassword") }}</h2>
          <div class="grid fluid">
            <div class="col-12 md:col-6 p-field">
              <div class="forget-pass-text">
                {{ this.$t("miCuenta.textos.password.1") }}
              </div>
              <div class="forget-pass-text">
                {{ this.$t("miCuenta.textos.password.2") }}
              </div>
            </div>
            <div class="col-12 md:col-6 p-field">
              <Button
                :disabled="isSubmitting"
                :label="$t('common.buttons.sendPassword')"
                class="button"
                id="update_password"
                @click="enviarResetPassword()"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="edit-profile-body myInvoices"
        id="myInvoices"
        :ref="'myInvoicesRef'"
      >
        <div class="container-white">
          <h2 v-html="$t('miCuenta.listaFacturas')"></h2>
          <p
            v-html="
              $t('miCuenta.historialFacturas', {
                link: 'https://ayuda.iciredimpagados.com/hc/es-es/requests/new?ticket_form_id=360000635554',
              })
            "
          ></p>
          <ListadoDocumentos
            v-if="this.cliente && this.cliente.uuid"
            :tipo="tipoFicheroFacturas"
            :clave="this.cliente.uuid"
            :header="$t('miCuenta.listaFacturas')"
            :label="$t('documento.dataTable.invoice')"
            class="marginBottom"
            :key="'ListaFacturas' + displayUploadDocument"
          />
          <p id="noInvoices" v-if="!this.cliente.uuid">
            <b>{{ $t("documento.dataTable.noInvoices") }}</b>
          </p>
        </div>
      </div>
      <div class="edit-profile-body">
        <div class="container-white">
          <div class="col-12 md:col-4">
            <Button
              icon="pi pi-home"
              :label="$t('common.buttons.home')"
              class="button darkBlueBG"
              id="update_password"
              @click="goToRoot()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_USUARIO_BY_UUID,
  MODIFICA_USUARIO,
  ASIGNAR_AVATAR,
  CAMBIAR_EMAIL_USUARIO,
  ENVIAR_RESET_PASSWORD,
  MUTATION_MODIFY_COMMERCIAL_COMMUNICATIONS,
} from "@/graphQLQueries/UsuarioQueries";
import {
  MODIFICA_CLIENTE,
  ALTA_CLIENTE,
  GET_CLIENTE,
} from "@/graphQLQueries/ClienteQueries";

import { TIPOS_FICHEROS } from "@/resources/constants";

import validations from "@/utils/validations.js";

import MessagesMixin from "@/utils/messages";
import StringsMixin from "@/utils/strings.js";
import UsersMixin from "@/utils/users";
import RoutesMixin from "@/utils/routes";
import JavascriptMixin from "@/utils/javascript";

import ListadoDocumentos from "@/components/portal-cliente/Utils/ListadoDocumentos.vue";
import CTIAddress from "@/components/portal-cliente/Utils/CTIAddress";
import DireccionIcired from "@/components/portal-cliente/Utils/DireccionIcired.vue";

export const VALIDACIONES_CLIENTE = {
  nombre: true,
  apellidos: true,
  idLegal: true,
  telefono: true,
};

export const VALIDACIONES_USUARIO = {
  nombre: true,
  apellidos: true,
  idLegal: true,
  telefono: true,
};

export const VALIDACIONES_EMAIL = {
  nuevoEmail: true,
};

export default {
  mixins: [
    MessagesMixin,
    StringsMixin,
    UsersMixin,
    RoutesMixin,
    JavascriptMixin,
  ],
  name: "MiCuenta",
  components: {
    ListadoDocumentos,
    DireccionIcired,
    CTIAddress,
  },
  data() {
    return {
      usuario: {},
      nuevoEmail: "",
      oldEmail: "",
      genero: null,
      usuarioNif: null,
      usuarioTelefono: null,
      erroresDatosUsuario: [],
      validationUsuario: VALIDACIONES_USUARIO,
      cliente: {},
      clienteNif: null,
      oldClienteNif: null,
      clienteMail: null,
      clienteTelefono: null,
      erroresDatosCliente: [],
      validationCliente: VALIDACIONES_CLIENTE,
      canSubmitClient: false,
      commercialCommunications: false,
      erroresDatosEmail: [],
      validationEmail: VALIDACIONES_EMAIL,
      isSubmitting: false,
      displayUploadDocument: false,
      tipoFicheroFacturas: TIPOS_FICHEROS.FACTURAS_CLIENTE,
      isCifCompany: false,
      hashTag: null,
      noInvoices: true,
      loadingCTIAddressNormalization: false,
    };
  },
  apollo: {
    usuario: {
      query: GET_USUARIO_BY_UUID,
      variables() {
        return {
          uuidUsuario: this.$store.state.profile.uuid,
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        let user = data.getUsuarioUuid;

        if (user.contactosActivos && user.contactosActivos.email) {
          this.oldEmail = user.contactosActivos.email.valor.email;
        }

        this.genero = user.genero;
        // Guard: un usuario recien registrado puede no tener contactos todavia.
        let contactoTlf = user.contactosActivos && user.contactosActivos.telefono;
        if (contactoTlf && contactoTlf.valor.telefono) {
          this.usuarioTelefono = contactoTlf.valor.telefono;
        }
        if (validations.validateNif(user.idLegal)) {
          this.usuarioNif = user.idLegal;
        }
        if (user.clienteIdLegal) {
          this.getCliente(user.clienteIdLegal);
        }

        this.commercialCommunications = user.commercialCommunications;

        return user;
      },
    },
  },
  created() {
    this.hashTag = location.hash;
  },
  mounted() {
    if (this.hashTag) {
      this.noInvoices = false;
    }
  },
  watch: {
    usuarioNif(newValue) {
      this.validationUsuario.idLegal =
        this.$store.state.esGranCliente || validations.validateNif(newValue);
    },
    clienteNif(newValue) {
      this.isCifCompany = validations.isValidCif(newValue);
      //this.$set(this.validationCliente, 'apellidos',  this.isCifCompany  ? true : (this.cliente.apellidos ? true : false))
      this.$set(
        this.validationCliente,
        "idLegal",
        validations.validateNifOrCif(newValue)
      );
      this.canActiveButtonSubmitClient();
    },
    clienteTelefono(newValue) {
      this.$set(this.validationCliente, "telefono", newValue ? true : false);
      this.canActiveButtonSubmitClient();
    },
    "cliente.nombre"(newValue) {
      this.$set(this.validationCliente, "nombre", newValue ? true : false);
      this.canActiveButtonSubmitClient();
    },
    "cliente.apellidos"(newValue) {
      this.$set(
        this.validationCliente,
        "apellidos",
        validations.validateNifEmpresa(this.clienteNif)
          ? true
          : newValue
          ? true
          : false
      );
      this.canActiveButtonSubmitClient();
    },
  },
  computed: {
    labelClienteNombre() {
      if (this.isCifCompany) {
        return this.$t("miCuenta.labels.razonSocialCliente");
      } else {
        return this.$t("miCuenta.labels.nombreCliente");
      }
    },
    labelClienteApellidos() {
      if (!this.isCifCompany) {
        return this.$t("miCuenta.labels.apellidosCliente") + "*";
      }
      return "";
    },
    showApellidos() {
      return !this.isCifCompany;
    },
    clientNotVerifyValidations() {
      return this.clientNotComplyValidations();
    },
  },
  methods: {
    allValidationsClientFailed() {
      let self = this;
      Object.keys(self.validationCliente).forEach(function (key) {
        eval("self.validationCliente." + key + "= false");
      });
    },
    cambiarEmail() {
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: CAMBIAR_EMAIL_USUARIO,
          variables: {
            oldEmailUsuario: this.oldEmail,
            nuevoEmailUsuario: this.nuevoEmail,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.datosEmail"),
            3000
          );
          this.isSubmitting = false;
          this.erroresDatosEmail = [];
          this.$keycloak.logout();
        })
        .catch((exception) => {
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.datosEmail"),
            3000
          );
          this.erroresDatosEmail = [];
          exception.graphQLErrors.forEach((error) => {
            this.erroresDatosEmail.push(error.message);
          });
          this.isSubmitting = false;
          this.setErrorsAfterSubmitEmail();
        });
    },
    enviarResetPassword() {
      this.isSubmitting = true;
      this.$apollo
        .query({
          query: ENVIAR_RESET_PASSWORD,
          variables: {
            userEmail: this.oldEmail,
          },
        })
        .then(() => {
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.datosPassword"),
            3000
          );
          this.isSubmitting = false;
        })
        .catch((error) => {
          console.error(error);
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.datosPassword"),
            3000
          );
          this.isSubmitting = false;
        });
    },
    search() {
      this.$apollo.queries.usuario.refetch();
    },
    isChecked(generoUsuario) {
      this.genero == generoUsuario;
    },
    modificarUsuarioRequest() {
      return {
        tipo: this.usuario.literalTipoUsuarioDetalle
          ? this.usuario.literalTipoUsuarioDetalle.clave
          : null,
        idLegal: this.usuarioNif,
        nombre: this.usuario.nombre,
        apellidos: this.usuario.apellidos,
        uuid: this.usuario.uuid,
        telefono: this.usuarioTelefono,
      };
    },
    modificarCommercialCommunicationsRequest() {
      return {
        uuid: this.usuario.uuid,
        commercialCommunications: this.commercialCommunications,
      };
    },
    modificarGeneroRequest() {
      return { uuid: this.usuario.uuid, genero: this.genero };
    },
    modificarUsuario(modificarUsuario) {
      if (this.$store.state.esGranCliente || this.validationUsuario.idLegal) {
        this.isSubmitting = true;
        this.$apollo
          .mutate({
            mutation: MODIFICA_USUARIO,
            variables: {
              modificarUsuarioRequest: modificarUsuario,
              idioma: this.$i18n.locale,
            },
          })
          .then(() => {
            this.isSubmitting = false;
            this.resetValidationsUsuario();
            this.erroresDatosUsuario = [];
            this.setMessages(
              "success",
              this.$t("miCuenta.messages.success.datosUsuario"),
              3000
            );
          })
          .catch((exception) => {
            this.isSubmitting = false;
            this.setMessages(
              "error",
              this.$t("miCuenta.messages.error.datosUsuario"),
              3000
            );
            this.erroresDatosUsuario = [];
            exception.graphQLErrors.forEach((error) => {
              this.erroresDatosUsuario.push(error.message);
            });
            this.setErrorsAfterSubmitUsuario();
          });
      }
    },
    asignarAvatar(modificarUsuario) {
      this.$apollo
        .mutate({
          mutation: ASIGNAR_AVATAR,
          variables: {
            modificarUsuarioRequest: modificarUsuario,
          },
        })
        .then(() => {
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.avatar"),
            3000
          );
        })
        .catch((exception) => {
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.avatar"),
            3000
          );
          this.erroresDatosUsuario = [];
          exception.graphQLErrors.forEach((error) => {
            this.erroresDatosUsuario.push(error.message);
          });
        });
    },
    modificarCommercialCommunications(modificarUsuario) {
      this.$apollo
        .mutate({
          mutation: MUTATION_MODIFY_COMMERCIAL_COMMUNICATIONS,
          variables: {
            modificarUsuarioRequest: modificarUsuario,
          },
        })
        .then(() => {
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.commercialCommunications"),
            3000
          );
        })
        .catch((exception) => {
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.commercialCommunications"),
            3000
          );
          this.erroresDatosUsuario = [];
          exception.graphQLErrors.forEach((error) => {
            this.erroresDatosUsuario.push(error.message);
          });
        });
    },
    clientNotComplyValidations() {
      let arrayValidations = [].concat
        .apply([], Object.entries(this.validationCliente))
        .filter((validation) => !validation);
      return arrayValidations.length > 0;
    },
    modificarClienteRequest() {
      const direccionData = this.$refs.direccionComponent.getData();

      return {
        nombre: this.cliente.nombre,
        apellidos: this.isCifCompany ? null : this.cliente.apellidos,
        nuevoIdLegal: this.clienteNif,
        antiguoIdLegal: this.oldClienteNif,
        datosFacturacion: true,
        contactoDireccion: direccionData,
        contactoTelefono: { telefono: this.clienteTelefono },
      };
    },
    modificarCliente(modificaCliente) {
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: MODIFICA_CLIENTE,
          variables: {
            modificarClienteRequest: modificaCliente,
          },
        })
        .then((data) => {
          this.isSubmitting = false;
          this.resetValidationsCliente();
          this.erroresDatosCliente = [];
          this.oldClienteNif = data.data.modificarCliente.idLegal;
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.datosFacturacion"),
            3000
          );
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.datosFacturacion"),
            3000
          );
          this.erroresDatosCliente = [];
          exception.graphQLErrors.forEach((error) => {
            this.erroresDatosCliente.push(error.message);
          });
          this.setErrorsAfterSubmitCliente();
        });
    },
    altaClienteRequest() {
      const direccionData = this.$refs.direccionComponent.getData();
      return {
        nombre: this.cliente.nombre,
        apellidos: this.isCifCompany ? null : this.cliente.apellidos,
        idLegal: this.clienteNif,
        email: this.clienteMail ? this.clienteMail : this.oldEmail,
        datosFacturacion: true,
        uuidUsuario: this.usuario.uuid,
        contactoDireccion:direccionData,
        contactoTelefono: { telefono: this.clienteTelefono },
      };
    },
    altaCliente(altaCliente) {
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: ALTA_CLIENTE,
          variables: {
            altaClienteRequest: altaCliente,
            idioma: this.$i18n.locale,
          },
        })
        .then((data) => {
          this.isSubmitting = false;
          this.resetValidationsCliente();
          this.erroresDatosCliente = [];
          this.oldClienteNif = data.data.altaCliente.idLegal;
          // PA-3587: tras crear el cliente, refrescar la query de usuario para que
          // clienteIdLegal quede poblado y la pantalla se repueble sin recarga manual.
          this.$apollo.queries.usuario.refetch();
          this.setMessages(
            "success",
            this.$t("miCuenta.messages.success.datosFacturacion"),
            3000
          );
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.setMessages(
            "error",
            this.$t("miCuenta.messages.error.datosFacturacion"),
            3000
          );
          this.erroresDatosCliente = [];
          exception.graphQLErrors.forEach((error) => {
            this.erroresDatosCliente.push(error.message);
          });
          this.setErrorsAfterSubmitCliente();
        });
    },
    modificarOAltaCliente() {
      if (!this.clientNotComplyValidations()) {
        if (this.cliente && this.cliente.idLegal) {
          if (this.$refs.direccionComponent.valid()) {
            this.modificarCliente(this.modificarClienteRequest());
          }
        } else {
          this.altaCliente(this.altaClienteRequest());
        }
      }
    },
    getCliente(idLegalCliente) {
      this.$apollo
        .query({
          query: GET_CLIENTE,
          variables: {
            idLegal: idLegalCliente,
            idioma: this.$i18n.locale,
          },
          fetchPolicy: "no-cache",
        })
        .then((data) => {
          // Result
          this.cliente = data.data.cliente;
          this.clienteNif = this.cliente.idLegal;
          this.oldClienteNif = this.cliente.idLegal;

          if (this.cliente && this.cliente.contactosActivos) {
            if (this.cliente.contactosActivos.email) {
              this.clienteMail =
                this.cliente.contactosActivos.email.valor.email;
            }
            if (this.cliente.contactosActivos.telefono) {
              this.clienteTelefono =
                this.cliente.contactosActivos.telefono.valor.telefono;
            }
            if (this.cliente.contactosActivos.direccion) {
              const { valor } = this.cliente.contactosActivos.direccion;

              this.$refs.direccionComponent.setData(valor);
            }
            this.$set(
              this.validationCliente,
              "apellidos",
              validations.validateNifEmpresa(this.clienteNif)
                ? true
                : this.cliente.apellidos
                ? true
                : false
            );
            this.$set(
              this.validationCliente,
              "idLegal",
              validations.validateNif(this.clienteNif)
            );
            this.$set(
              this.validationCliente,
              "telefono",
              this.clienteTelefono ? true : false
            );
            this.$set(
              this.validationCliente,
              "nombre",
              this.cliente.nombre ? true : false
            );
            this.canActiveButtonSubmitClient();
          }
        })
        .catch((error) => {
          // Error
          console.error(error);
        });
    },
    resetValidationsCliente() {
      let self = this;

      if (self) {
        Object.keys(VALIDACIONES_CLIENTE).forEach(function (key) {
          eval("self.validationCliente." + key + "= true");
        });
      }
    },
    setErrorsAfterSubmitCliente() {
      this.resetValidationsCliente();
      if (
        this.erroresDatosCliente.includes("L3002") ||
        this.erroresDatosCliente.includes("L2002") ||
        this.erroresDatosCliente.includes("L2006") ||
        this.erroresDatosCliente.includes("L2001") ||
        this.erroresDatosCliente.includes("L3006") ||
        this.erroresDatosCliente.includes("L3007")
      ) {
        this.validationCliente.idLegal = false;
      }
      if (
        this.erroresDatosCliente.includes("L3004") ||
        this.erroresDatosCliente.includes("L2004")
      ) {
        this.validationCliente.nombre = false;
      }
      if (
        this.erroresDatosCliente.includes("L3005") ||
        this.erroresDatosCliente.includes("L2005")
      ) {
        this.validationCliente.apellidos = false;
      }
      if (
        this.erroresDatosCliente.includes("L3009") ||
        this.erroresDatosCliente.includes("L2009")
      ) {
        this.validationCliente.telefono = false;
      }
      if (this.erroresDatosCliente.includes("C0006")) {
        this.validationCliente.tipoDireccion = false;
      }
      if (this.erroresDatosCliente.includes("C0007")) {
        this.validationCliente.direccion = false;
      }
      if (this.erroresDatosCliente.includes("C0008")) {
        this.validationCliente.localidad = false;
      }
      if (this.erroresDatosCliente.includes("C0009")) {
        this.validationCliente.provincia = false;
      }
      if (this.erroresDatosCliente.includes("C0010")) {
        this.validationCliente.pais = false;
      }
      if (
        this.erroresDatosCliente.includes("C0011") ||
        this.erroresDatosCliente.includes("C0012")
      ) {
        this.validationCliente.codigoPostal = false;
      }
    },
    resetValidationsUsuario() {
      let self = this;

      if (self) {
        Object.keys(VALIDACIONES_USUARIO).forEach(function (key) {
          eval("self.validationUsuario." + key + "= true");
        });
      }
    },
    setErrorsAfterSubmitUsuario() {
      this.resetValidationsUsuario();
      if (
        this.erroresDatosUsuario.includes("U2003") ||
        this.erroresDatosUsuario.includes("U2011") ||
        this.erroresDatosUsuario.includes("U3002") ||
        this.erroresDatosUsuario.includes("U3010")
      ) {
        this.validationUsuario.idLegal = false;
      }
      if (
        this.erroresDatosUsuario.includes("U2006") ||
        this.erroresDatosUsuario.includes("U3005")
      ) {
        this.validationUsuario.nombre = false;
      }
      if (
        this.erroresDatosUsuario.includes("U2007") ||
        this.erroresDatosUsuario.includes("U3006")
      ) {
        this.validationUsuario.apellidos = false;
      }
      if (
        this.erroresDatosUsuario.includes("U2019") ||
        this.erroresDatosUsuario.includes("U3017")
      ) {
        this.validationUsuario.telefono = false;
      }
    },
    resetValidationsEmail() {
      let self = this;

      if (self) {
        Object.keys(VALIDACIONES_EMAIL).forEach(function (key) {
          eval("self.validationEmail." + key + "= true");
        });
      }
    },
    setErrorsAfterSubmitEmail() {
      this.resetValidationsEmail();
      if (this.erroresDatosEmail.length > 0) {
        this.validationEmail.nuevoEmail = false;
      }
    },
    canActiveButtonSubmitClient() {
      var validationsFailed = false;
      if (!this.clienteNif || !validations.validateNifOrCif(this.clienteNif)) {
        validationsFailed = true;
      }
      if (!this.clienteTelefono) {
        validationsFailed = true;
      }
      if (!this.cliente.nombre) {
        validationsFailed = true;
      }
      if (
        !this.cliente.apellidos &&
        !validations.validateNifEmpresa(this.clienteNif)
      ) {
        validationsFailed = true;
      }
      if (!validationsFailed) {
        this.canSubmitClient = true;
      }
    },
  },
};
</script>

<style lang="scss">
</style>
